const getValue = (item) => (key) => {
  let value = key === 'externalId' ? item.studentExternalId : item[key];

  // convert en dash to minus so that this char is displayed properly on CSV
  if (typeof value === 'string') {
    value = value.replace('−', '-');
  }

  if (typeof value === 'string' && value.includes(',')) {
    return `"${value}"`;
  }
  return value;
};

const jsToCsv = (
  columns,
  data,
  fieldDisplayNames = {},
  ssAstudentIdShowInCsVandSubList
) => {
  const exportColumns = ssAstudentIdShowInCsVandSubList
    ? columns
    : columns.filter((col) => col !== 'customStudentId');

  // Create header row with display names if provided, otherwise use column names
  const headerRow = exportColumns
    .map((col) => fieldDisplayNames[col] || col)
    .join(',');

  // Create data rows using original field names
  const dataRows = data.reduce((accum, item) => {
    const row = exportColumns.map(getValue(item)).join(',');
    return `${accum}\r\n${row}`;
  }, '');

  return `${headerRow}${dataRows}`;
};

export default jsToCsv;
